import { Routes } from '@angular/router';
import { roleGuard } from './auth/auth.guard';
import { ADMIN, CUSTOMER } from './auth/authenticationRoles';

export const routes: Routes = [
  {
    path: '',
    loadComponent: () => import('./views/home/home.component').then(m => m.HomeComponent)
  },
   {
    path: 'about',
    loadComponent: () => import('./views/about/about.component').then(m => m.AboutComponent)
  },
  {
    path: 'classes',
    loadComponent: () => import('./views/classes/classes.component').then(m => m.ClassesComponent)
  },
  {
    path: 'practical',
    loadComponent: () => import('./views/practical/practical.component').then(m => m.PracticalComponent)
  },
  {
    path: 'coming-soon',
    loadComponent: () => import('./views/target-audience/target-audience.component').then(m => m.TargetAudienceComponent)
  },
  {
    path: 'values',
    loadComponent: () => import('./views/values/values.component').then(m => m.ValuesComponent)
  },
  {
    path: 'offer',
    loadComponent: () => import('./views/offer/offer.component').then(m => m.OfferComponent)
  },
  {
   path: 'calendar',
    canActivate: [roleGuard(CUSTOMER) || roleGuard(ADMIN)],
    loadComponent: () => import('./views/calendar/calendar.component').then(m => m.CalendarComponent)
    //loadComponent: () => import('./views/target-audience/target-audience.component').then(m => m.TargetAudienceComponent)
  },
  {
    path: 'checkout',
    canActivate: [roleGuard(CUSTOMER) || roleGuard(ADMIN)],
    loadComponent: () => import('./views/checkout/checkout.component').then(m => m.CheckoutComponent)
  },
  {
    path: 'payment-status',
    canActivate: [roleGuard(CUSTOMER) || roleGuard(ADMIN)],
    loadComponent: () => import('./views/payment-status/payment-status.component').then(m => m.PaymentStatusComponent)
  },
  {
    path: 'login',
    loadComponent: () => import('./views/login/login.component').then(m => m.LoginComponent)
  },
  {
    // The frame. Each tab is a URL of its own, so a section can be linked to and
    // reloaded; the bare path opens the first tab.
    path: 'admin',
    canActivate: [roleGuard(ADMIN)],
    loadComponent: () => import('./views/admin/admin.component').then(m => m.AdminComponent),
    children: [
      { path: '', pathMatch: 'full', redirectTo: 'classes' },
      {
        path: 'classes',
        loadComponent: () => import('./views/admin/admin-pilates-classes.component').then(m => m.AdminPilatesClassesComponent)
      },
      {
        path: 'payments',
        loadComponent: () => import('./views/admin/admin-payments.component').then(m => m.AdminPaymentsComponent)
      },
      {
        path: 'vouchers',
        loadComponent: () => import('./views/admin/admin-vouchers.component').then(m => m.AdminVouchersComponent)
      },
      {
        path: 'bookings',
        loadComponent: () => import('./views/admin/admin-bookings.component').then(m => m.AdminBookingsComponent)
      },
      {
        path: 'booking-managing',
        loadComponent: () => import('./views/admin/admin-booking-managing.component').then(m => m.AdminBookingManagingComponent)
      },
      {
        path: 'reporting',
        loadComponent: () => import('./views/admin/admin-reporting.component').then(m => m.AdminReportingComponent)
      }
    ]
  },
  {
    path: 'overview',
    canActivate: [roleGuard(CUSTOMER)],
    loadComponent: () => import('./views/customer/overview/overview.component').then(m => m.OverviewComponent)
  },
  //{ path: '**', redirectTo: '' }
];
